module.exports = __webpack_public_path__ + "static/production_drafting-1bc8621f54e30b028fe43ba28a3b0be3.jpg";